var Params = {
	IMAGEDIRECTORY: "/assets/images/",
	LANGUAGE:"jp",
	IS_MOBILE: false,
	IS_TABLET: false,
	POPUP_LINK: "",

	STAGE_WIDTH: 0,
	STAGE_HEIGHT: 0,

	TABLET_VIEW: ['ipad', 'android'],
	MOBILE_VIEW: ['ie6', 'ie7', 'ie8', 'ipod', 'iphone', 'mobile'],
	PC_VIEW: ['ie9', 'ie10', 'ie11', 'chrome', 'safari', 'opera', 'gecko'],

	GET_BANNER: false,
	GET_ALERT: false,

	API_DOMAIN: ""

}


module.exports = Params;
